
















import { defineComponent, onMounted, ref } from "@vue/composition-api";
import "@toast-ui/editor/dist/toastui-editor.css";
import "@toast-ui/editor/dist/theme/toastui-editor-dark.css";
import BaseInputBox from "@/components/BaseInputBox";
import ToastUiEditor from "@/components/ToastUiEditor";
import { defaultEditorOptions } from "./config";

export default defineComponent({
  name: "WysiwygEditor",
  components: {
    ToastUiEditor,
    BaseInputBox,
  },
  props: {
    value: { type: String, required: true },
    label: { type: String, default: "" },
    name: { type: String, default: "" },
    options: { type: Object as () => typeof defaultEditorOptions, default: () => defaultEditorOptions },
  },
  setup(_, { emit }) {
    const toastuiEditor = ref();
    const onChange = (html: string = "") => {
      emit("input", html);
    };

    onMounted(() => {
      emit("uploadImageHandler", toastuiEditor.value.editor.eventEmitter);
    });

    return {
      toastuiEditor,
      onChange,
    };
  },
});
